import request from '@/utils/request.js'

/** 油罐列表 */
export function searchGasTankList ({ page, limit, name, number, status, site_name, site_number }) {
  return request({
    url: '/oiltank/index',
    method: 'get',
    params: {
      page, limit, name, number, status, site_name, site_number
    }
  })
}

/** 获取油罐下拉列表 */
export function searchGasTankCodeList ({ page, limit, station_id, type }) {
  return request({
    url: '/oiltank/option',
    method: 'get',
    params: {
      page,
      limit,
      type,
      station_id
    }
  })
}

/** 新增油罐 */
export function addGasTank ({ station_id, name, number, volume, status, warn, type, unit, oil_number }) {
  return request({
    url: '/oiltank/add',
    method: 'post',
    data: {
      station_id, name, number, volume, status, warn, type, unit, oil_number
    }
  })
}

/** 编辑油罐 */
export function editGasTank ({ station_id, name, number, volume, status, warn, type, unit, oil_number, id }) {
  return request({
    url: '/oiltank/edit',
    method: 'post',
    data: {
      station_id, name, number, volume, status, warn, type, unit, id, oil_number
    }
  })
}

/** 删除油罐 */
export function deleteGasTank (ids) {
  return request({
    url: '/oiltank/del',
    method: 'get',
    params: {
      ids
    }
  })
}

/** 油罐选项 */
export function gasTankParams ({ station_id }) {
  return request({
    url: '/tank/getStation',
    method: 'get',
    params: {
      station_id
    }
  })
}
